/**
 * Application Entry Point
 *
 * Initializes React, React Query, Router, and Authentication
 */

import { apiClient } from '@medsuite/api-client';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { QueryProvider, ThemeProvider } from './providers';
import { AuthProvider } from './providers/AuthProvider';
import { router } from './router';
import './index.css';

try {
  // Configure API client
  apiClient.configure({
    baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api',
    timeout: 30000,
  });

  createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <AuthProvider>
        <QueryProvider>
          <ThemeProvider>
            <RouterProvider router={router} />
          </ThemeProvider>
        </QueryProvider>
      </AuthProvider>
    </React.StrictMode>
  );

} catch (error) {
  console.error('Error during app initialization:', error);
  document.body.innerHTML = `
    <div style="padding: 20px; font-family: monospace;">
      <h1 style="color: red;">Application Error</h1>
      <p>${error instanceof Error ? error.message : 'Unknown error'}</p>
      <pre>${error instanceof Error ? error.stack : ''}</pre>
    </div>
  `;
}
